import { API_URL, ACTIONS } from "UTILS/Constants";
import BaseAction from "CONFIG/BaseAction";
import { HTTP_METHODS } from "UTILS/Constants";
import logo from "ASSETS/Images/img_header_logo.webp";

export class OrganisationAction extends BaseAction {
  constructor() {
    super();
    BaseAction.call(this);
    this.timeout = 10000;
  }
  
  getAllCustomersAction() {
    return new Promise((resolve, reject) => {
      this.callApi({
        httpMethod: HTTP_METHODS.GET,
        url: API_URL.CUSTOMER
      }).then(
        response => {
          resolve(response);          
        },
        error => {
          reject(error);
        }
      );
    });
  }

  addCustomerWithAdminAction(customerWithAdminData) {
    return new Promise((resolve, reject) => {
      this.callApi({
        httpMethod: HTTP_METHODS.POST,
        url: API_URL.CUSTOMER_WITH_ADMIN,
        requestBody: customerWithAdminData
      }).then(
        response => {
          resolve(response);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  saveCustomerAction(customerData,customerId) {
    return new Promise((resolve, reject) => {
      this.callApi({
        httpMethod: HTTP_METHODS.PUT,
        url: `${API_URL.CUSTOMER}/${customerId}`,
        requestBody: customerData
      }).then(
        response => {
          resolve(response);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  deleteCustomerAction(customerId) {
    return new Promise((resolve, reject) => {
      this.callApi({
        httpMethod: HTTP_METHODS.DELETE,
        url: `${API_URL.CUSTOMER}/${customerId}`,
      }).then(
        response => {
          resolve(response);
        },
        error => {
          reject(error);
        }
      );
    });
  }
  
  getServerStatusAction(){
    return new Promise((resolve, reject) => {
      this.callApi({
        httpMethod: HTTP_METHODS.GET,
        url: API_URL.KMS_STATUS,
      }).then(
        response => {
          resolve(response);
        },
        error => {
          reject(error);
        }
      );
    });
  }
  
  uploadOrgLogoStatusAction(formData){
    return new Promise((resolve, reject) => {
      this.callApi({
        httpMethod: HTTP_METHODS.POST,
        url: API_URL.USER_UPLOAD_FILE,
        requestBody: formData
      }).then(
        response => {
          resolve(response);
        },
        error => {
          reject(error);
        }
      );
    });
  }
  
  uploadOrgTenantWordingStatusAction(formData){
    return new Promise((resolve, reject) => {
      this.callApi({
        httpMethod: HTTP_METHODS.POST,
        url: API_URL.USER_UPLOAD_TENANT_WORDING_FILE,
        requestBody: formData
      }).then(
        response => {
          resolve(response);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  getOrgWordingUrlAction(customerId, uriIdentifier){
    return new Promise((resolve , reject) =>{
      this.callApi({
        httpMethod: HTTP_METHODS.GET,
        requestBody: {
          customerId: `${customerId}`,
          uriIdentifier: `${uriIdentifier}`,
        },
        url: API_URL.USER_GET_WORDING_FILE_URL
      }).then(
        response =>{
          this.dispatch({
            type: ACTIONS.SET_WORDING_URL,
            wordingUrl: response.data.data.fileUrl
          });
          this.dispatch({
            type: ACTIONS.SET_IS_WORDING_FETCHED,
            isWordingFetched: true
          });
          resolve(response);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  userStatisticsAction(){
    return new Promise((resolve, reject) => {
      this.callApi({
        httpMethod: HTTP_METHODS.GET,
        url: API_URL.USER_STATISTICS
      }).then(
        response => {
          resolve(response);
          this.dispatch({
            type: ACTIONS.SET_SESSIONS_CAPACITY,
            sessionsCapacity: {
              systemMaxCapacity: response.data.data.systemMaxCapacity,
              usedCapacity: response.data.data.usedCapacity
            } 
          })
        },
        error => {
          reject(error);
        }
      );
    });
  }

  getMSClusterStatistcsAction(){
    return new Promise((resolve , reject) =>{
      this.callApi({
        httpMethod: HTTP_METHODS.GET,
        url: API_URL.MSCLUSTER_STATISTICS
      }).then(
        response =>{
          resolve(response);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  async getTurnClusterStatisticsAction(){
    return new Promise((resolve , reject) =>{
      this.callApi({
        httpMethod: HTTP_METHODS.GET,
        url: API_URL.TURNCLUSTER_STATISTICS
      }).then(
        response =>{
          resolve(response);
        },
        error => {
          reject(error);
        }
      );
    });
  }
  
  retireMsClusterInstanceAction(instanceIds){
    return new Promise((resolve , reject) =>{
      this.callApi({
        httpMethod: HTTP_METHODS.PUT,
        url: API_URL.MSCLUSTER_RETIREINSTANCE,
        requestBody: { 
          "instanceIds": instanceIds
        }
      }).then(
        response =>{
          resolve(response);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  saveCurrentActiveTab(activeTab){
    this.dispatch({ 
      type: ACTIONS.ORGANISATION_ACTION.SET_ACTIVE_TAB,
      value: activeTab
    });
  }

  getCustomerStatisticsAction(customerId){
    return new Promise((resolve, reject) => {
      this.callApi({
        httpMethod: HTTP_METHODS.GET,
        url: `${API_URL.CUSTOMER}/${customerId}/statistics`
      }).then(
        response => {
          resolve(response);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  getCustomersAction(customerId) {
    return new Promise((resolve, reject) => {
      this.callApi({
        httpMethod: HTTP_METHODS.GET,
        url: `${API_URL.CUSTOMER}/${customerId}`
      }).then(
        response => {
          this.dispatch({
            type: ACTIONS.SET_MODULES,
            modules: response.data.data.modules
          });
          this.dispatch({
            type: ACTIONS.SET_ALLOWED_DOWNLOAD,
            subModules: response.data.data.subModules
          });
          this.dispatch({
            type: ACTIONS.SET_CUSTOMER_DATA,
            customerData:response.data.data 
          })
          this.dispatch({
            type: ACTIONS.SET_PASSCODE_STATUS,
            isPasscodeEnabled: response.data.data.is_passcode_enabled
          }); 
          this.dispatch({
            type: ACTIONS.SET_ADMIN_LOGO_URL,
            logoUrl: response.data.data.logo ? response.data.data.logo : logo
          });
          if(response.data.data.cobrowseSettings) {
            this.dispatch({
              type: ACTIONS.CO_BROWSE.SET_CO_BROWSE_DETAILS,
              cobrowseSettings: response.data.data.cobrowseSettings
            });
          }
          if(response.data.data.sender_id) {
            this.dispatch({
              type: ACTIONS.SENDER_ID,
              cobrowseSettings: response.data.data.sender_id
            });
          }
          if(response.data.data.operatorSkills) {
            this.dispatch({
              type: ACTIONS.SUPPORT_CENTER.SET_SKILL_LIST,
              operatorSkills: response.data.data.operatorSkills
            });
          }

          resolve(response);          
        },
        error => {
          reject(error);
        }
      );
    });
  }

  updateUrl(logoUrl, customerId) {
    return new Promise((resolve, reject) => {
      this.callApi({
        httpMethod: HTTP_METHODS.PUT,
        url: `${API_URL.UPDATE_URL}/${customerId}`,
        requestBody: { logoUrl: logoUrl }
      }).then(
        response => {
          resolve(response);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  //to get available storage options on settings click 
  getCustomerStorageDetails(customerId){
    return new Promise((resolve, reject) => {
      this.callApi({
        httpMethod: HTTP_METHODS.GET,
        url: `${API_URL.CUSTOMER_STORAGE}/${customerId}`,
      }).then(
        response => {
          resolve(response);         
        },
        error => {
          reject(error);
        }
      );
    });
  }
  //to get available recording storage options on settings click 
  getCustomerRecordingStorageDetails(customerId){
    return new Promise((resolve, reject) => {
      this.callApi({
        httpMethod: HTTP_METHODS.GET,
        url: `${API_URL.CUSTOMER_RECORDING_STORAGE}/${customerId}`,
      }).then(
        response => {
          resolve(response);         
        },
        error => {
          reject(error);
        }
      );
    });
  }
  //to verify storage on adding new
  verifyStorage(storageElement){
    return new Promise((resolve, reject) => {
      this.callApi({
        httpMethod: HTTP_METHODS.POST,
        url: `${API_URL.VERIFY_STORAGE}`,
        requestBody:storageElement
      }).then(
        response => {
          resolve(response);          
        },
        error => {
          reject(error);
        }
      );
    });
  }
  //updates settings of customer/admin
  updateCustomerSettings(customerId, newSettings) {
    return this.callApi({
      httpMethod: HTTP_METHODS.PUT,
      url: `${API_URL.CUSTOMER_SETTINGS}/${customerId}`,
      requestBody: newSettings,
    })
  }

  setLogoUrl(logoUrl) {
    this.dispatch({
      type: ACTIONS.SET_ADMIN_LOGO_URL,
      logoUrl: logoUrl
    });
  }

  getCustomerFromLicenseAction(licenseKey){
    return new Promise((resolve, reject) => {
      this.callApi({
        httpMethod: HTTP_METHODS.GET,
        url: `${API_URL.GET_CUSTOMER}/${licenseKey}`
      }).then(
        response => {
          resolve(response);
        },
        error => {
          reject(error);
        }
      );
    });
  } 

  setOrganisationAction(organization){
    this.dispatch({
      type: ACTIONS.ORGANISATION_ACTION.SET_ORGANIZATION_DATA,
      organization: organization
    })
  }

  getCustomerSmsSendNum() {
    return new Promise((resolve, reject) => {
      this.callApi({
        httpMethod: HTTP_METHODS.GET,
        url: `${API_URL.GET_CUSTOMER_SMS_SEND_NUM}`,
      }).then(
        response => {
          resolve(response);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  getCustomerSessionNum(customerSessionDetail) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        reject(new Error("timeout"))
      }, this.timeout)

      this.callApi({
        httpMethod: HTTP_METHODS.GET,
        requestBody: customerSessionDetail,
        url: `${API_URL.GET_CUSTOMER_SESSION_NUM}`,
      }).then(
        response => {
          resolve(response);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  downloadCustomerSessionNumCSV(customerSessionDetail) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        reject(new Error("timeout"))
      }, this.timeout)

      this.callApi({
        httpMethod: HTTP_METHODS.GET,
        requestBody: customerSessionDetail,
        url: `${API_URL.DOWNLOAD_CUSTOMER_SESSION_NUM_CSV}`,
        header: {"Accept": "text/csv"},
        responseType: 'blob',
      }).then(
        response => {
          resolve(response);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  getCustomerEncodingTime() {
    return new Promise((resolve, reject) => {
      this.callApi({
        httpMethod: HTTP_METHODS.GET,
        url: `${API_URL.GET_CUSTOMER_ENCODING_TIME}`,
      }).then(
        response => {
          resolve(response);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  getCustomerFiscalYearReport(customerId, fiscalYear) {
    let baseURL = API_URL.DEVICES_REPORT.replace('{customerId}', `${customerId}`);
    baseURL += '/?fiscalYear=' + fiscalYear;

    return new Promise((resolve, reject) => {
      this.callApi({
        httpMethod: HTTP_METHODS.GET,
        url: baseURL
      }).then(
        response => {
          resolve(response);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  /**
    * Fetches the concurrent report data for a specific customer and fiscal year.
    * 
    * @param {string} customerId - The ID of the customer.
    * @param {number} fiscalYear - The fiscal year for which the report is requested.
    * @returns {<Object>} - returns data object of concurrent connections aggregated by year
    */
  getCustomerConcurrentReportData(customerId, fiscalYear) {
    let baseURL = API_URL.CONCURRENT_REPORT_COBROWSE.replace('{customerId}', `${customerId}`);
    baseURL += '/?fiscalYear=' + fiscalYear;
    console.log(baseURL);

    return new Promise((resolve, reject) => {
      this.callApi({
        httpMethod: HTTP_METHODS.GET,
        url: baseURL
      }).then(
        response => {
          resolve(response);
          console.log(response.data);
        },
        error => {
          reject(error);
        }
      );
      
    });    
  }

  /**
   * Fetches the monthly concurrent sessions report for all organizations for a given fiscal year.
   * 
   * @param {number} fiscalYear - The fiscal year for which the monthly report is requested.
   * @returns {Promise<Object>} - Returns a promise with the monthly concurrent sessions data.
   */
  getMonthlyConcurrentSessionsReport(fiscalYear) {
    return new Promise((resolve, reject) => {
      this.callApi({
        httpMethod: HTTP_METHODS.GET,
        url: `${API_URL.CONCURRENT_REPORT_MONTHLY}?year=${fiscalYear}`
      }).then(
        response => {
          resolve(response);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  /**
   * Fetches the daily concurrent sessions report for all organizations for a given year and month.
   * 
   * @param {number} year - The year for which the daily report is requested.
   * @param {string} month - The month (01-12) for which the daily report is requested.
   * @returns {Promise<Object>} - Returns a promise with the daily concurrent sessions data.
   */
  getDailyConcurrentSessionsReport(year, month) {
    return new Promise((resolve, reject) => {
      this.callApi({
        httpMethod: HTTP_METHODS.GET,
        url: `${API_URL.CONCURRENT_REPORT_DAILY}?year=${year}&month=${month}`
      }).then(
        response => {
          resolve(response);
        },
        error => {
          reject(error);
        }
      );
    });
  }

}
